"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoriesIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
// eslint-disable-next-line css-modules/no-unused-class
const ConsumerNavIcon_module_css_1 = __importDefault(require("../../ConsumerNavIcon.module.css"));
/**
 * Icon for Discover homepage
 */
function StoriesIcon(props) {
    const baseClasses = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.v2Icon, { [ConsumerNavIcon_module_css_1.default.active]: props.active });
    const pathClasses = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.ba);
    const titleId = "stories-icon-title";
    return ((0, jsx_runtime_1.jsxs)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: baseClasses, "aria-describedby": titleId, children: [(0, jsx_runtime_1.jsx)("title", { id: titleId, children: "Watch Snapchat Stories" }), (0, jsx_runtime_1.jsx)("path", { d: "M15.2388 3.82609H21.7356C22.9862 3.82609 24 4.83988 24 6.09046V20.6922C24 21.9427 22.9862 22.9565 21.7356 22.9565H15.2388C13.9882 22.9565 12.9744 21.9427 12.9744 20.6922V6.09046C12.9744 4.83988 13.9882 3.82609 15.2388 3.82609ZM2.26437 0H8.76125C10.0118 0 11.0256 1.01379 11.0256 2.26437V16.8661C11.0256 18.1166 10.0118 19.1304 8.76125 19.1304H2.26437C1.01379 19.1304 0 18.1166 0 16.8661V2.26437C0 1.01379 1.01379 0 2.26437 0Z", className: pathClasses })] }));
}
exports.StoriesIcon = StoriesIcon;
//# sourceMappingURL=StoriesIcon.js.map